// PR 45 review · M11 + D1: the J14 / J15 card lines — opening-balance postings not tested, and an approver column that is
// only on part of the GL (EN + AR). Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B31R_JE = {
  en: {
    a9001: {
      cardParam: {
        j14System: "{n} system postings not tested (opening balances)",
        j14Partly: "Partly assessable — {n} lines without an approver column",
      },
    },
  },
  ar: {
    a9001: {
      cardParam: {
        j14System: "{n} من قيود النظام لم تُختبر (الأرصدة الافتتاحية)",
        j14Partly: "قابل للتقييم جزئيًا — {n} من الأسطر بلا عمود معتمد",
      },
    },
  },
};

export default I18N_B31R_JE;
